import { render, staticRenderFns } from "./join-success-dialog.vue?vue&type=template&id=8d268b48&scoped=true&"
import script from "./join-success-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./join-success-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./join-success-dialog.vue?vue&type=style&index=0&id=8d268b48&prod&lang=less&scoped=true&"
import style1 from "./join-success-dialog.vue?vue&type=style&index=1&id=8d268b48&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d268b48",
  null
  
)

export default component.exports